import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
// Third party packages
import { MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { finalize, take } from 'rxjs/operators';
// Custom packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { CompaniesService } from 'src/app/modules/companies/companies.service';
import { InterventionsService } from 'src/app/modules/interventions/interventions.service';
import { ConfirmDialogComponent } from 'src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component';
import { Intervention } from 'src/app/shared/models/intervention/intervention.model';
import { ConfigService } from 'src/app/shared/services/config.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { AddContractorDialogComponent } from '../../components/add-contractor-dialog/add-contractor-dialog.component';
import { AddReceivedDocumentDialogComponent } from '../../components/add-receivedDocument-dialog/add-receivedDocument-dialog.component';
import { AddTaxDeductionFeeDialogComponent } from '../../components/add-taxDeductionFee-dialog/add-taxDeductionFee-dialog.component';
import { EditContractorDialogComponent } from '../../components/edit-contractor-dialog/edit-contractor-dialog.component';
import { EditReceivedDocumentDialogComponent } from '../../components/edit-receivedDocument-dialog/edit-receivedDocument-dialog.component';
import { EditTaxDeductionFeeDialogComponent } from '../../components/edit-taxDeductionFee-dialog/edit-taxDeductionFee-dialog.component';
var InterventionDetailComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function InterventionDetailComponent(configService, activatedRoute, interventionsService, router, toastrService, helperService, translateService, themeService, authService, dialog, cookieService, companiesService) {
        this.configService = configService;
        this.activatedRoute = activatedRoute;
        this.interventionsService = interventionsService;
        this.router = router;
        this.toastrService = toastrService;
        this.helperService = helperService;
        this.translateService = translateService;
        this.themeService = themeService;
        this.authService = authService;
        this.dialog = dialog;
        this.cookieService = cookieService;
        this.companiesService = companiesService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.intervention = new Intervention();
        this.sortedContractorsData = [];
        this.initialContractorsData = [];
        this.sortedTaxDeductionFeesData = [];
        this.initialTaxDeductionFeesData = [];
        this.sortedReceivedDocumentsData = [];
        this.initialReceivedDocumentsData = [];
        this.detailCardIsLoading = true;
        this.deleteCardIsLoading = true;
        this.contractorsCardIsLoading = true;
        this.taxDeductionFeesCardIsLoading = true;
        this.receivedDocumentsCardIsLoading = true;
        // BEGIN - Add intervention form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.notesField = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.save'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'primary',
            spinnerColor: 'primary',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-save',
                inline: true,
            },
        };
        // END - Add intervention form
        this.deleteBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.delete'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'warn',
            spinnerColor: 'warn',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-trash',
                inline: true,
            },
        };
        this.displayedTotal = 0;
        this.previousValue = {};
        this.availableOptions = [];
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Set page title
        this.themeService.setPageTitle(this.translateService.instant('interventions.detail.pageTitle'));
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return _this.loggedUser = res; }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return _this.loggedUserPermissions = res; }));
        // Get current lang
        this.lang = this.cookieService.get('lang') || this.configService.defaultLang;
        // Get requested intervention data
        var interventionId = this.activatedRoute.snapshot.params.interventionId;
        this.subscriptions.push(this.interventionsService.get(interventionId).subscribe(function (res) {
            if (res.status) {
                _this.loadInterventionData(res.data);
                return;
            }
            // Something bad happened
            // redirect user to interventions list
            _this.router.navigate([_this.lang, 'app', 'interventions', 'list']);
        }, function (err) {
            // if we came here users with given userId do not exist
            _this.helperService.handleError(err);
            _this.router.navigate([_this.lang, 'errors', '404']);
        }));
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all interventions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle params change
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.loadInterventionData = function (intervention) {
        // Set permission data
        this.intervention.setData(intervention);
        // Set contractors
        this.sortedContractorsData = this.intervention.get("contractors");
        this.initialContractorsData = JSON.parse(JSON.stringify(this.sortedContractorsData));
        this.contractorsCardIsLoading = false;
        // Set taxDeductionFees
        this.sortedTaxDeductionFeesData = this.intervention.get("taxDeductionFees");
        this.initialTaxDeductionFeesData = JSON.parse(JSON.stringify(this.sortedTaxDeductionFeesData));
        this.taxDeductionFeesCardIsLoading = false;
        // Set receivedDocuments
        this.sortedReceivedDocumentsData = this.intervention.get("receivedDocuments");
        this.initialReceivedDocumentsData = JSON.parse(JSON.stringify(this.sortedReceivedDocumentsData));
        this.receivedDocumentsCardIsLoading = false;
        // Stop loading in delete form
        this.deleteCardIsLoading = false;
        // Init edit form
        this.initForm();
        // Make detail form card visible by disabling his card-spinner
        this.detailCardIsLoading = false;
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.initForm = function () {
        // Set model
        this.model = this.intervention.getData();
        // Set fields
        this.fields = [
            {
                fieldGroupClassName: 'row',
                fieldGroup: [
                    {
                        className: 'col-12 col-sm-6',
                        type: 'input',
                        key: 'name',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.name'),
                            placeholder: this.translateService.instant('interventions.fields.name'),
                            required: true,
                            minLength: 2,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12 col-sm-6',
                        type: 'input',
                        key: 'propertyName',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.propertyName'),
                            placeholder: this.translateService.instant('interventions.fields.propertyName'),
                            required: false,
                            minLength: 2,
                            maxLength: 100,
                        },
                    },
                    {
                        className: 'col-12 col-sm-6 col-md-4 col-lg-3',
                        type: 'input',
                        key: 'type',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.type'),
                            placeholder: this.translateService.instant('interventions.fields.type'),
                            required: false,
                        },
                    },
                    {
                        className: 'col-12 col-sm-6 col-md-4 col-lg-3',
                        type: 'datepicker',
                        key: 'meetingResolutionDate',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.meetingResolutionDate'),
                            placeholder: this.translateService.instant('interventions.fields.meetingResolutionDate'),
                        },
                    },
                    {
                        className: 'col-12 col-sm-6 col-md-4 col-lg-3',
                        type: 'input',
                        key: 'totalFee',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.totalFee'),
                            placeholder: this.translateService.instant('interventions.fields.totalFee'),
                            required: false,
                            type: 'number',
                            step: 0.1,
                            min: 0,
                        },
                    },
                    {
                        className: 'col-12 col-sm-6 col-md-4 col-lg-3',
                        type: 'input',
                        key: 'constructionManagement',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.constructionManagement'),
                            placeholder: this.translateService.instant('interventions.fields.constructionManagement'),
                            required: false,
                            minLength: 2,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12 col-sm-6 col-md-4 col-lg-3',
                        type: 'input',
                        key: 'securityCoordinator',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.securityCoordinator'),
                            placeholder: this.translateService.instant('interventions.fields.securityCoordinator'),
                            required: false,
                            minLength: 2,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12 col-sm-6 col-md-4 col-lg-3',
                        type: 'datepicker',
                        key: 'constructionStart',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.constructionStart'),
                            placeholder: this.translateService.instant('interventions.fields.constructionStart'),
                        },
                    },
                    {
                        className: 'col-12 col-sm-6 col-md-4 col-lg-3',
                        type: 'datepicker',
                        key: 'constructionEnd',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.constructionEnd'),
                            placeholder: this.translateService.instant('interventions.fields.constructionEnd'),
                        },
                    },
                    {
                        className: 'col-12 col-sm-6 col-md-4 col-lg-3',
                        type: 'input',
                        key: 'taxDeductionType',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.taxDeductionType'),
                            placeholder: this.translateService.instant('interventions.fields.taxDeductionType'),
                            required: false,
                            minLength: 2,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12',
                        type: 'textarea',
                        key: 'notes',
                        templateOptions: {
                            label: this.translateService.instant('interventions.fields.notes'),
                            placeholder: this.translateService.instant('interventions.fields.notes'),
                            required: false,
                            minLength: 1,
                            maxLength: 5000,
                            rows: 5,
                        },
                        expressionProperties: {
                            'templateOptions.description': '(model[field.key]||"").length+"/" +field.templateOptions.maxLength',
                        }
                    }
                ],
            },
        ];
    };
    /**
     * Open contractor add dialog
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.onAddContractor = function () {
        var _this = this;
        if (!this.intervention || !this.intervention.getId()) {
            return;
        }
        // Open dialog
        var dialogRef = this.dialog.open(AddContractorDialogComponent, {
            minWidth: '60%',
            maxHeight: '98vh',
            data: {
                interventionId: this.intervention.getId()
            }
        });
        // On dialog closing, check if something is changed
        // If so, let's reload table data
        this.subscriptions.push(dialogRef.afterClosed()
            .subscribe(function (res) {
            if (typeof res !== 'undefined'
                && res.newIntervention
                && res.newIntervention.contractors) {
                _this.sortedContractorsData = res.newIntervention.contractors;
                _this.intervention.setData(res.newIntervention);
                return;
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Open contractor add dialog
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.onEditContractor = function (contractor) {
        var _this = this;
        if (!this.intervention || !this.intervention.getId() || !contractor || !contractor._id) {
            this.toastrService.error(this.translateService.instant('interventions.errors.missing_contractor'));
            return;
        }
        // Open dialog
        var dialogRef = this.dialog.open(EditContractorDialogComponent, {
            minWidth: '60%',
            maxHeight: '98vh',
            data: {
                interventionId: this.intervention.getId(),
                contractor: contractor,
            }
        });
        // On dialog closing, check if something is changed
        // If so, let's reload table data
        this.subscriptions.push(dialogRef.afterClosed().subscribe(function (res) {
            if (typeof res !== 'undefined'
                && res.updatedIntervention
                && res.updatedIntervention.contractors) {
                _this.sortedContractorsData = res.updatedIntervention.contractors;
                _this.intervention.setData(res.updatedIntervention);
                return;
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Handle table sort
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.sortContractorsData = function (sort) {
        var _this = this;
        var data = this.sortedContractorsData;
        if (!sort.active || sort.direction === '') {
            this.sortedContractorsData = JSON.parse(JSON.stringify(this.initialContractorsData));
            return;
        }
        this.sortedContractorsData = data.sort(function (a, b) {
            var isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'name': return _this.compare(a.name, b.name, isAsc);
                case 'fee': return _this.compare(a.fee, b.fee, isAsc);
                default: return 0;
            }
        });
    };
    /**
     * Open taxDeductionFee add dialog
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.onAddTaxDeductionFee = function () {
        var _this = this;
        if (!this.intervention || !this.intervention.getId()) {
            return;
        }
        // Open dialog
        var dialogRef = this.dialog.open(AddTaxDeductionFeeDialogComponent, {
            minWidth: '60%',
            maxHeight: '98vh',
            data: {
                interventionId: this.intervention.getId()
            }
        });
        // On dialog closing, check if something is changed
        // If so, let's reload table data
        this.subscriptions.push(dialogRef.afterClosed()
            .subscribe(function (res) {
            if (typeof res !== 'undefined'
                && res.newIntervention
                && res.newIntervention.taxDeductionFees) {
                _this.sortedTaxDeductionFeesData = res.newIntervention.taxDeductionFees;
                _this.intervention.setData(res.newIntervention);
                return;
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Open taxDeductionFee add dialog
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.onEditTaxDeductionFee = function (taxDeductionFee) {
        var _this = this;
        if (!this.intervention || !this.intervention.getId() || !taxDeductionFee || !taxDeductionFee._id) {
            this.toastrService.error(this.translateService.instant('interventions.errors.missing_taxDeductionFee'));
            return;
        }
        // Open dialog
        var dialogRef = this.dialog.open(EditTaxDeductionFeeDialogComponent, {
            minWidth: '60%',
            maxHeight: '98vh',
            data: {
                interventionId: this.intervention.getId(),
                taxDeductionFee: taxDeductionFee,
            }
        });
        // On dialog closing, check if something is changed
        // If so, let's reload table data
        this.subscriptions.push(dialogRef.afterClosed().subscribe(function (res) {
            if (typeof res !== 'undefined'
                && res.updatedIntervention
                && res.updatedIntervention.taxDeductionFees) {
                _this.sortedTaxDeductionFeesData = res.updatedIntervention.taxDeductionFees;
                _this.intervention.setData(res.updatedIntervention);
                return;
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Handle table sort
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.sortTaxDeductionFeesData = function (sort) {
        var _this = this;
        var data = this.sortedTaxDeductionFeesData;
        if (!sort.active || sort.direction === '') {
            this.sortedTaxDeductionFeesData = JSON.parse(JSON.stringify(this.initialTaxDeductionFeesData));
            return;
        }
        this.sortedTaxDeductionFeesData = data.sort(function (a, b) {
            var isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'year': return _this.compare(a.year, b.year, isAsc);
                case 'fee': return _this.compare(a.fee, b.fee, isAsc);
                case 'resolved': return _this.compare(a.resolved, b.resolved, isAsc);
                default: return 0;
            }
        });
    };
    /**
     * Toggle taxDeductionFee's "resolved" property
     * and updates the whole intervention
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.onToggleTaxDeductionFee = function (itemId, checked) {
        var _this = this;
        var taxDeductionFees = this.intervention.get("taxDeductionFees");
        if (Array.isArray(taxDeductionFees) && taxDeductionFees.length) {
            var element = taxDeductionFees.find(function (el) { return el._id === itemId; });
            if (element) {
                element.resolved = checked;
            }
        }
        else {
            this.toastrService.error("Error: taxDeductionFees is not an array");
        }
        var model = JSON.parse(JSON.stringify(this.intervention.getData()));
        this.subscriptions.push(this.interventionsService.update(this.intervention.getId(), model)
            .pipe(finalize(function () { return _this.formBtnOptions.active = false; }))
            .subscribe(function (res) {
            if (res.status && res.data) {
                _this.intervention.setData(res.data);
                _this.toastrService.success(res.message);
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Open receivedDocument add dialog
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.onAddReceivedDocument = function () {
        var _this = this;
        if (!this.intervention || !this.intervention.getId()) {
            return;
        }
        // Open dialog
        var dialogRef = this.dialog.open(AddReceivedDocumentDialogComponent, {
            minWidth: '60%',
            maxHeight: '98vh',
            data: {
                interventionId: this.intervention.getId()
            }
        });
        // On dialog closing, check if something is changed
        // If so, let's reload table data
        this.subscriptions.push(dialogRef.afterClosed()
            .subscribe(function (res) {
            if (typeof res !== 'undefined'
                && res.newIntervention
                && res.newIntervention.receivedDocuments) {
                _this.sortedReceivedDocumentsData = res.newIntervention.receivedDocuments;
                _this.intervention.setData(res.newIntervention);
                return;
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Open receivedDocument add dialog
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.onEditReceivedDocument = function (receivedDocument) {
        var _this = this;
        if (!this.intervention || !this.intervention.getId() || !receivedDocument || !receivedDocument._id) {
            this.toastrService.error(this.translateService.instant('interventions.errors.missing_receivedDocument'));
            return;
        }
        // Open dialog
        var dialogRef = this.dialog.open(EditReceivedDocumentDialogComponent, {
            minWidth: '60%',
            maxHeight: '98vh',
            data: {
                interventionId: this.intervention.getId(),
                receivedDocument: receivedDocument,
            }
        });
        // On dialog closing, check if something is changed
        // If so, let's reload table data
        this.subscriptions.push(dialogRef.afterClosed().subscribe(function (res) {
            if (typeof res !== 'undefined'
                && res.updatedIntervention
                && res.updatedIntervention.receivedDocuments) {
                _this.sortedReceivedDocumentsData = res.updatedIntervention.receivedDocuments;
                _this.intervention.setData(res.updatedIntervention);
                return;
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Handle table sort
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.sortReceivedDocumentsData = function (sort) {
        var _this = this;
        var data = this.sortedReceivedDocumentsData;
        if (!sort.active || sort.direction === '') {
            this.sortedReceivedDocumentsData = JSON.parse(JSON.stringify(this.initialReceivedDocumentsData));
            return;
        }
        this.sortedReceivedDocumentsData = data.sort(function (a, b) {
            var isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'name': return _this.compare(a.name, b.name, isAsc);
                case 'description': return _this.compare(a.description, b.description, isAsc);
                case 'received': return _this.compare(a.received, b.received, isAsc);
                default: return 0;
            }
        });
    };
    /**
     * Toggle receivedDocument's "received" property
     * and updates the whole intervention
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.onToggleReceivedDocument = function (itemId, checked) {
        var _this = this;
        var receivedDocuments = this.intervention.get("receivedDocuments");
        if (Array.isArray(receivedDocuments) && receivedDocuments.length) {
            var element = receivedDocuments.find(function (el) { return el._id === itemId; });
            if (element) {
                element.received = checked;
            }
        }
        else {
            this.toastrService.error("Error: receivedDocuments is not an array");
        }
        var model = JSON.parse(JSON.stringify(this.intervention.getData()));
        this.subscriptions.push(this.interventionsService.update(this.intervention.getId(), model)
            .pipe(finalize(function () { return _this.formBtnOptions.active = false; }))
            .subscribe(function (res) {
            if (res.status && res.data) {
                _this.intervention.setData(res.data);
                _this.toastrService.success(res.message);
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Utility per table sort
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.compare = function (a, b, isAsc) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    };
    /**
     * Handle intervention status change
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.onStatusChange = function () {
        var _this = this;
        var status = this.model.status;
        if (!status) {
            return;
        }
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant('dialogs.confirm.title'),
                message: this.translateService.instant('interventions.status.changeMessage'),
                btnOkText: this.translateService.instant('common.cta.confirm'),
                btnCancelText: this.translateService.instant('common.cta.undo'),
            },
            width: '500px',
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef.beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                // User hit decline button
                return;
            }
            // User hit confirm button
            _this.subscriptions.push(_this.interventionsService.changeStatus(_this.intervention.getId(), { status: status })
                .subscribe(function (res2) {
                if (res2.status && res2.intervention) {
                    var newIntervention = tslib_1.__assign({}, _this.intervention.getData(), { status: res2.intervention.status });
                    _this.toastrService.success(res2.message);
                    _this.loadInterventionData(newIntervention);
                }
            }, function (err) {
                // Choose one of the following error handling
                // method. The first one shows a message right
                // under the form fields (if the form is properly
                // setted), the second one shows toastr
                // notifications for each error
                // this.helperService.handleFormError(this.passwordForm, err);
                _this.helperService.handleError(err);
            }));
        });
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.onFormSubmit = function () {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant('common.errors.form_is_invalid'));
            return;
        }
        // Activate submit button loading status
        this.formBtnOptions.active = true;
        // Handle intervention notes
        // if (this.model.notes.text) {
        //   this.notes.push({
        //     text: this.model.notes.text,
        //     createdAt: moment().toISOString(),
        //     createdBy: this.loggedUser._id,
        //   });
        //   this.model.notes = this.notes;
        // }
        this.subscriptions.push(this.interventionsService.update(this.intervention.getId(), this.model)
            .pipe(finalize(function () { return _this.formBtnOptions.active = false; }))
            .subscribe(function (res) {
            if (res.status) {
                var previousProperty = _this.intervention.get("property");
                _this.intervention.setData(res.data);
                _this.intervention.set("property", previousProperty);
                // // Add string name to the last created note (so we can inject it in dialog)
                // const lastNote = this.notes[this.notes.length - 1];
                // if (lastNote) {
                //   const newNote = {
                //     ...lastNote,
                //     createdBy: {
                //       _id: lastNote.createdBy,
                //       name: `${this.loggedUser.firstName} ${this.loggedUser.lastName}`
                //     },
                //   };
                //   this.notes[this.notes.length - 1] = newNote;
                // }
                _this.toastrService.success(res.message);
            }
        }, function (err) {
            // Choose one of the following error handling method.
            // 1) First one show a message right under the form fields
            //    (if the form is properly setted)
            // 2) Second one is used to show a mat-error under each field
            //    in the dynamic form (is meant to be used only in dynamicForm)
            // 3) Third one show toastr notifications for each error
            // 4) Fourth one is used to show mat-error under each field
            //    in the ngx-formly form (is mean to be used only with ngx-formly)
            // this.helperService.handleFormError(form, err);
            // this.helperService.handleDynamicFormError(form, err);
            // this.helperService.handleError(err);
            _this.helperService.handleFormlyError(_this.form, err);
        }));
    };
    /**
     * Remove current user from database
     *
     * @since 1.0.0
     */
    InterventionDetailComponent.prototype.onDelete = function () {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant('dialogs.confirm.title'),
                message: this.translateService.instant('dialogs.confirm.message'),
                btnOkText: this.translateService.instant('common.cta.confirm'),
                btnCancelText: this.translateService.instant('common.cta.undo'),
            },
            width: '500px',
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef.beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.subscriptions.push(_this.interventionsService.delete(_this.intervention.getId())
                .pipe(finalize(function () { return _this.deleteBtnOptions.active = false; }))
                .subscribe(function (res2) {
                _this.toastrService.success(res2.message);
                // Once the user is deleted, redirect to list
                _this.router.navigate([_this.lang, 'app', 'interventions', 'list']);
                return;
            }, function (err) {
                // Choose one of the following error handling
                // method. The first one shows a message right
                // under the form fields (if the form is properly
                // setted), the second one shows toastr
                // notifications for each error
                // this.helperService.handleFormError(this.passwordForm, err);
                _this.helperService.handleError(err);
            }));
        });
    };
    return InterventionDetailComponent;
}());
export { InterventionDetailComponent };
